import Link from "next/link";
import { useKeenSlider } from "keen-slider/react";
import { BlogCard, useGetAllAuthorsQuery, useGetBlogPostsQuery } from "@entities/blog";
import { RouterConfig } from "@shared/lib/routerConfig";
import { Container } from "@shared/ui/container";
import { LeftIcon } from "@shared/ui/Icon/ui/Common/LeftIcon";
import { RightIcon } from "@shared/ui/Icon/ui/Common/RightIcon";
import { BlogWidgetProps } from "./types";
import classes from "./blog-widget.module.scss";

export const BlogWidget = ({ title, showAll, id }: BlogWidgetProps) => {
    const { data: posts } = useGetBlogPostsQuery({
        count: 3,
        page: 1,
        exclude: id ?? 0
    });

    const [sliderRef, sliderInstance] = useKeenSlider({
        slides: {
            perView: 2,
            spacing: 15
        },
        breakpoints: {
            "(min-width: 900px)": {
                slides: {
                    perView: 3,
                    spacing: 20
                }
            }
        },
        loop: false
    });

    const emptyDataBlog = !posts?.data?.length;

    if (emptyDataBlog) {
        return null;
    }

    return (
        <div className={classes["blog-widget"]}>
            <Container>
                <div className={classes["blog-widget__header"]}>
                    <h2 className={classes["blog-widget__title"]}>{title}</h2>
                    {showAll && (
                        <Link href={RouterConfig.BLOG} className={classes["blog-widget__link"]}>
                            Смотреть все
                        </Link>
                    )}
                </div>
                <div ref={sliderRef} className="keen-slider">
                    {posts.data.map((item) => {
                        if (item.status === "publish" && item.slug) {
                            return (
                                <div className="keen-slider__slide" key={item.id}>
                                    <BlogCard
                                        slug={item.slug}
                                        title={item.title?.rendered ?? ""}
                                        date={item.date}
                                        image={
                                            item.x_featured_media_large ??
                                            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/up7PQAJEQNZlBQt7QAAAABJRU5ErkJggg=="
                                        }
                                        authorName={item.x_author}
                                        avatarLink={item.x_gravatar}
                                        views={item.views ?? null}
                                    />
                                </div>
                            );
                        }
                    })}
                </div>
                <div className={classes["blog-widget__nav"]}>
                    <div
                        className={classes["blog-widget__arrow"]}
                        onClick={() => sliderInstance.current?.prev()}
                    >
                        <LeftIcon className={classes["blog-widget__arrow--color"]} />
                    </div>
                    <div
                        className={classes["blog-widget__arrow"]}
                        onClick={() => sliderInstance.current?.next()}
                    >
                        <RightIcon className={classes["blog-widget__arrow--color"]} />
                    </div>
                </div>
            </Container>
        </div>
    );
};